import { AfterViewInit, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { LoaderService } from '../../services/loader.service';
import { SecurityService } from '../../services/security.service';
import { Router } from '@angular/router';
import { ModalComponent } from "../../shared/modal/modal.component";
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-finish',
  imports: [ModalComponent],
  templateUrl: './finish.component.html',
  styleUrl: './finish.component.css'
})
export class FinishComponent implements OnInit, AfterViewInit {
  showModalPap = signal(false);
  showModalInfo = signal(false);
  showPapIframe = signal(false);
  papIframeUrl: SafeResourceUrl = '';
  valuesVinculation:any = {
    valueOne: 40000,
    valueTwo: 0,
  }
  nextRoute: WritableSignal<string> = signal('');

  constructor(
    private _router: Router,
    private _title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _routeService: RouteService,
    private _helpService: HelpService,
    private sanitizer: DomSanitizer,
  ) {
    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
    this._title.setTitle('Onboarding Digital | Finalización');

   }

  async ngOnInit() {
    const authRoute = localStorage.getItem('route');
    if(!authRoute) {
      this._router.navigateByUrl('');
    }
    const currentUrl = this._router.url;
    if(authRoute && currentUrl !== authRoute) {
      await this._router.navigateByUrl(authRoute);
    } else {
      this._helpService.hide();
      this._loaderService.hide();
      this._securityService.getQuota().subscribe({
        next: (response:any) => {
          this.valuesVinculation.valueTwo = response.quota;
        }
      });
    }
  }

  countThousands(value: string | number): string {
    const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    if (isNaN(num)) return '0';
    return num.toLocaleString('es-CO');
  }

  /**
   * Remapea solo origen si hay papFincoAppUrl; conserva path + query
   * (CtrlInterfazAppExterno?ID=...) para no romper la sesión FincoApp.
   */
  private resolvePapUrl(sUrl: string): string {
    if (!sUrl) return '';
    const baseUrl = environment.papFincoAppUrl;
    if (!baseUrl) {
      return sUrl;
    }
    try {
      const original = new URL(sUrl);
      const target = new URL(baseUrl);
      original.protocol = target.protocol;
      original.host = target.host;
      return original.toString();
    } catch {
      return sUrl;
    }
  }

  async next() {
    this.showModalPap.set(false);
    this._loaderService.show('Abriendo tu ahorro programado...');
    this._securityService.getInterfazApp().subscribe({
      next: (response: any) => {
        const interfaceRoute = this.resolvePapUrl(response?.data?.sUrl);
        if (!interfaceRoute) {
          this._loaderService.hide();
          return;
        }
        this.papIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(interfaceRoute);
        this._loaderService.hide();
        this.showPapIframe.set(true);
      },
      error: () => {
        this._loaderService.hide();
      },
    });
  }

  finish() {
    localStorage.clear();
    window.location.href = 'https://www.fincomercio.com';
  }

  contactWhitAsesor(){
    const phone = localStorage.getItem('phone') || '';
    const message = encodeURIComponent('Hola, estoy interesado en recibir asesoría sobre la vinculación a Fincomercio.');
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }

  downloadPDF() {
    this._securityService.getPDF().subscribe((response: any) => {
      const file = `${environment.serverUrl}/${response.pdfFile}`;
      const url = file;
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.download = 'vinculacionDigitalFincomercio.pdf'; // Nombre del archivo descargado
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showModalInfo.set(true);
    }, 1000);
    if(this.showModalInfo() == false){
      setTimeout(() => {
        this.showModalPap.set(true);
      }, 8000);
    }
  }


}
